import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './SearchHeader.css'; // Import CSS file

const SearchHeader = () => {
  return (
    <header className="search-header">
      <div className="banner-container">
        <img src={`${process.env.PUBLIC_URL}/banner.jpg`} alt="Banner" className="banner-image" />
      </div>
    </header>
  );
};

export default SearchHeader;
